// @generated by protoc-gen-es v1.10.0
// @generated from file ai/h2o/mlops/deployer/v1/deployment.proto (package ai.h2o.deploy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, Timestamp } from "@bufbuild/protobuf";
import { Security } from "./security_pb.js";
import { User } from "./user_pb.js";
import { Monitor } from "./monitor_pb.js";
import { MonitoringOptions } from "../../monitoring/v2/monitoring_options_pb.js";
import { DeploymentComposition } from "./deployment_composition_pb.js";
import { KubernetesResourceSpec } from "./kubernetes_resource_spec_pb.js";
import { KubernetesConfigurationShortcut } from "./kubernetes_configuration_pb.js";
import { DeploymentEnvironmentVariables } from "./deployment_environment_variables_pb.js";
import { VpaResourceSpec } from "./vpa_resource_spec_pb.js";
import { PodDisruptionBudgetSpec } from "./pdb_spec_pb.js";

/**
 * Represents a deployment of a model.
 *
 * @generated from message ai.h2o.deploy.Deployment
 */
export const Deployment = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.deploy.Deployment",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "project_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "deployment_environment_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "created_time", kind: "message", T: Timestamp },
    { no: 5, name: "last_modified_time", kind: "message", T: Timestamp },
    { no: 6, name: "single_deployment", kind: "message", T: SingleDeployment, oneof: "deployment" },
    { no: 7, name: "shadow_deployment", kind: "message", T: ShadowDeployment, oneof: "deployment" },
    { no: 8, name: "split_deployment", kind: "message", T: SplitDeployment, oneof: "deployment" },
    { no: 9, name: "security", kind: "message", T: Security },
    { no: 10, name: "display_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "revision_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "revision_create_time", kind: "message", T: Timestamp },
    { no: 15, name: "user_info", kind: "message", T: User },
    { no: 17, name: "customCors", kind: "message", T: Cors },
    { no: 18, name: "monitor", kind: "message", T: Monitor },
    { no: 19, name: "monitoring_options", kind: "message", T: MonitoringOptions },
  ],
);

/**
 * Represents a deployment with a single element.  That one element handles all incoming traffic.
 *
 * @generated from message ai.h2o.deploy.SingleDeployment
 */
export const SingleDeployment = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.deploy.SingleDeployment",
  () => [
    { no: 1, name: "deployment_composition", kind: "message", T: DeploymentComposition },
    { no: 4, name: "kubernetes_resource_spec", kind: "message", T: KubernetesResourceSpec, oneof: "environment_spec" },
    { no: 5, name: "kubernetes_configuration_shortcut", kind: "message", T: KubernetesConfigurationShortcut, oneof: "environment_shortcut" },
    { no: 6, name: "deployment_environment_variables", kind: "message", T: DeploymentEnvironmentVariables },
    { no: 7, name: "vpa_spec", kind: "message", T: VpaResourceSpec },
    { no: 8, name: "pod_disruption_budget", kind: "message", T: PodDisruptionBudgetSpec },
  ],
);

/**
 * Represents a deployment with multiple elements. The primary element responds to all incoming
 * requests.  The secondary element receives a copy of all requests, but its responses are not
 * returned.
 *
 * This deployment type is useful for implementing the Champion/Challenger scenario.
 *
 * @generated from message ai.h2o.deploy.ShadowDeployment
 */
export const ShadowDeployment = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.deploy.ShadowDeployment",
  () => [
    { no: 1, name: "primary_element", kind: "message", T: ShadowElement },
    { no: 2, name: "secondary_element", kind: "message", T: ShadowElement },
  ],
);

/**
 * @generated from message ai.h2o.deploy.ShadowElement
 */
export const ShadowElement = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.deploy.ShadowElement",
  () => [
    { no: 1, name: "deployment_composition", kind: "message", T: DeploymentComposition },
    { no: 4, name: "kubernetes_resource_spec", kind: "message", T: KubernetesResourceSpec, oneof: "environment_spec" },
    { no: 5, name: "kubernetes_configuration_shortcut", kind: "message", T: KubernetesConfigurationShortcut, oneof: "environment_shortcut" },
    { no: 6, name: "deployment_environment_variables", kind: "message", T: DeploymentEnvironmentVariables },
    { no: 7, name: "vpa_spec", kind: "message", T: VpaResourceSpec },
    { no: 8, name: "pod_disruption_budget", kind: "message", T: PodDisruptionBudgetSpec },
  ],
);

/**
 * Represents a deployment with multiple elements. Each element receives a portion of the request
 * traffic.
 *
 * This deployment type is useful for implementing the A/B testing scenario.
 *
 * @generated from message ai.h2o.deploy.SplitDeployment
 */
export const SplitDeployment = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.deploy.SplitDeployment",
  () => [
    { no: 1, name: "split_elements", kind: "message", T: SplitElement, repeated: true },
  ],
);

/**
 * Elements receive a percentage of the request traffic consistent with their relative `weight`.
 * For example, if there are three elements with weights 5, 10 and 35, the elements receives
 * 10%, 20% and 70% of the traffic, respectively.
 *
 * @generated from message ai.h2o.deploy.SplitElement
 */
export const SplitElement = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.deploy.SplitElement",
  () => [
    { no: 1, name: "deployment_composition", kind: "message", T: DeploymentComposition },
    { no: 2, name: "weight", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "kubernetes_resource_spec", kind: "message", T: KubernetesResourceSpec, oneof: "environment_spec" },
    { no: 6, name: "kubernetes_configuration_shortcut", kind: "message", T: KubernetesConfigurationShortcut, oneof: "environment_shortcut" },
    { no: 7, name: "deployment_environment_variables", kind: "message", T: DeploymentEnvironmentVariables },
    { no: 8, name: "vpa_spec", kind: "message", T: VpaResourceSpec },
    { no: 9, name: "pod_disruption_budget", kind: "message", T: PodDisruptionBudgetSpec },
  ],
);

/**
 * Cors represents the user specified CORS configuration for a deployment.
 *
 * @generated from message ai.h2o.deploy.Cors
 */
export const Cors = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.deploy.Cors",
  () => [
    { no: 1, name: "origins", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

